/**
 * 环境变量统一管理
 * 所有环境变量都在这里统一导出，避免在代码中直接使用 import.meta.env
 */

export const API_BASE_URL = import.meta.env["PUBLIC_API_BASE_URL"];

export const IS_DEV = import.meta.env.DEV;
export const ENABLE_DEVTOOLS =
  import.meta.env["PUBLIC_ENABLE_DEVTOOLS"] === "true" || IS_DEV;

const envEnableMock = import.meta.env["PUBLIC_ENABLE_MOCK"];
export const ENABLE_MOCK =
  envEnableMock !== undefined && envEnableMock !== ""
    ? envEnableMock === "true"
    : IS_DEV;

// export const ANALYTICS_ID = import.meta.env["PUBLIC_ANALYTICS_ID"] || "";
// export const SENTRY_DSN = import.meta.env["PUBLIC_SENTRY_DSN"] || "";
export const WEBSITE_LINK = import.meta.env["PUBLIC_WEBSITE_LINK"] || "";

export const SOURCEMAP = import.meta.env["PUBLIC_SOURCEMAP"] === "true";
export const DROP_CONSOLE = import.meta.env["PUBLIC_DROP_CONSOLE"] === "true";
/**
 * 功能开关
 */
export const featureFlags = {
  enableDevtools: ENABLE_DEVTOOLS,
  enableMock: ENABLE_MOCK,
} as const;

/**
 * 第三方服务配置
 */
export const thirdPartyConfig = {
  // analyticsId: ANALYTICS_ID || "",
  // sentryDsn: SENTRY_DSN || "",
  websiteLink: WEBSITE_LINK || "",
} as const;

/**
 * 构建配置
 */
export const buildConfig = {
  sourcemap: SOURCEMAP,
  dropConsole: DROP_CONSOLE,
} as const;
